export default __webpack_public_path__ + "static/hi-im-mark-e666b5595f310cd8c3833e74d3806976.svg";